import { OnInit, Component } from '@angular/core'
import { ScrollService } from '@service/scroll.service';

@Component({
  template: ''
})
export abstract class ProfileStateComponent implements OnInit {

  constructor(
    protected scrollService: ScrollService
  ) { }

  ngOnInit() {
    this.scrollService.scrollToTop()
  }

}
